import React from 'react';
import Styles from "./index.module.css";

const LinearProgressWithLabel = (props) => {
    return (
        <div className={Styles.outerContainer}>
            Task Manager
        </div>
    );
}

export default LinearProgressWithLabel;